import React from 'react';
import './forms.css';

const GeneralDel = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLScpfOXRGhs91qjegt0n9_GJ7Z_1A7c6E1dQQoxBLJAYoPtxSg/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="General Delegate Form"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default GeneralDel;
